import { RadioChangeEvent, Space } from 'antd';
import { pipe } from 'ramda';
import React, { FC, useCallback, useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { TimesheetApprovalType } from 'api/timesheets/configuration/configuration';
import { Radio } from 'components/atoms/radio';
import { RadioGroup } from 'components/atoms/radio-buttons';
import { useTranslation } from 'hooks/use-translation';
import { ControlPanel } from '../control-panel';
import { SetState, State } from '../state';

interface Props {
  approvalType: State<TimesheetApprovalType>;
  onApprovalTypeChange: SetState<TimesheetApprovalType>;
}

const StyledRadioGroup = styled(RadioGroup)`
  ${Radio} {
    color: var(--gray-80);
    display: inline-flex;
    align-items: center;
    min-height: 40px;
  }
`;

export const ApprovalsSettings: FC<Props> = ({
  approvalType,
  onApprovalTypeChange,
}) => {
  const label = useTranslation('settings.timesheets.controls.approvals.label');
  const description = useTranslation(
    'settings.timesheets.controls.approvals.description',
  );
  const approvalValue = useMemo(
    () => pipe(() => approvalType[1])(),
    [approvalType],
  );

  const onTypeChange = useCallback(
    (e: RadioChangeEvent) => {
      onApprovalTypeChange(e.target.value);
    },
    [onApprovalTypeChange],
  );

  return (
    <ControlPanel label={label} descriptions={[description]}>
      <StyledRadioGroup value={approvalValue} onChange={onTypeChange}>
        <Space direction="vertical">
          <Radio value={TimesheetApprovalType.ProjectOwner}>
            <FormattedMessage id="settings.timesheets.controls.approvals.project.owners" />
          </Radio>
          <Radio value={TimesheetApprovalType.Manager}>
            <FormattedMessage id="settings.timesheets.controls.approvals.managers" />
          </Radio>
        </Space>
      </StyledRadioGroup>
    </ControlPanel>
  );
};
